import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const LOC = { san_antolin: 'San Antolín', san_martin: 'San Martín', ria_niembro: 'Ría de Niembro' };

export default function ConfirmPage() {
  const { token } = useParams();
  const [state, setState] = useState('loading');
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`/api/confirm/${token}`)
      .then(r => r.json())
      .then(d => { if (d.ok) { setData(d); setState('success'); } else setState('error'); })
      .catch(() => setState('error'));
  }, [token]);

  const wrap = { display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', background:'#F5F2ED', padding:16 };
  const card = { background:'white', borderRadius:16, padding:32, maxWidth:420, width:'100%', textAlign:'center', boxShadow:'0 4px 24px rgba(0,0,0,.12)', fontFamily:'sans-serif' };

  if (state === 'loading') return (
    <div style={wrap}><div style={card}>
      <p style={{ color:'#4A6D7C', fontSize:18 }}>Confirmando tu reserva... / Confirming your booking...</p>
    </div></div>
  );

  if (state === 'error') return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize:56, marginBottom:16 }}>❌</div>
        <h2 style={{ color:'#1A2B3C', margin:'0 0 8px' }}>Enlace no válido / Invalid link</h2>
        <p style={{ color:'#8A9BA8', margin:0 }}>Este enlace no es válido o ya ha sido procesado.</p>
        <p style={{ color:'#8A9BA8', margin:'8px 0 0' }}>This link is not valid or has already been used.</p>
      </div>
    </div>
  );

  return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize:64, marginBottom:16 }}>✅</div>
        <h2 style={{ color:'#1A2B3C', margin:'0 0 4px' }}>¡Reserva confirmada!</h2>
        <h3 style={{ color:'#4A6D7C', margin:'0 0 16px', fontWeight:500, fontSize:16 }}>Booking confirmed!</h3>
        <p style={{ color:'#555', margin:'0 0 4px' }}>
          Hola <strong>{data.reservation_name}</strong>, tu plaza está confirmada.
        </p>
        <p style={{ color:'#555', margin:'0 0 24px' }}>
          Hi <strong>{data.reservation_name}</strong>, your spot is confirmed.
        </p>
        <div style={{ background:'#F0F7F4', borderRadius:8, padding:16, textAlign:'left', marginBottom:20 }}>
          <p style={{ margin:'4px 0', color:'#1A2B3C' }}><strong>📅</strong> {data.course_date}</p>
          <p style={{ margin:'4px 0', color:'#1A2B3C' }}><strong>🕐</strong> {data.course_time}</p>
          <p style={{ margin:'4px 0', color:'#1A2B3C' }}><strong>📍</strong> {LOC[data.course_location] || data.course_location}</p>
        </div>
        <p style={{ color:'#81B29A', fontSize:14, fontWeight:600, margin:'0 0 2px' }}>¡Nos vemos en el agua! 🌊</p><p style={{ color:'#81B29A', fontSize:14, fontWeight:600, margin:0 }}>See you in the water! 🌊</p>
      </div>
    </div>
  );
}
